<section class="hero">
  @if (preferences.language() === 'ar') {
    <img
      class="hero-art"
      src="/assets/images/landing-page/banner.webp"
      alt=""
      aria-hidden="true"
      fetchpriority="high"
      loading="eager"
      decoding="async"
    />
  } @else {
    <img
      class="hero-art is-en"
      src="/assets/images/landing-page/banner-en.webp"
      alt=""
      aria-hidden="true"
      fetchpriority="high"
      loading="eager"
      decoding="async"
    />
  }
  <div class="hero-copy">
    <h1>{{ preferences.t('landing.hero.title') }}</h1>
    <p>{{ preferences.t('landing.hero.subtitle') }}</p>
    <button type="button" routerLink="/personal-fund-request/personal-data">
      <span>{{ preferences.t('landing.hero.cta') }}</span>
      <app-icon class="arrow" name="chevron-left" aria-hidden="true" />
    </button>
  </div>
</section>

<form
  class="tracking-card request-form"
  [attr.aria-label]="preferences.t('landing.tracking.title')"
  (ngSubmit)="searchRequest()"
>
  <div class="tracking-heading">
    <span class="tracking-icon" aria-hidden="true">
      <img src="/assets/images/landing-page/file.svg" alt="" />
    </span>
    <div class="text-start">
      <h2>{{ preferences.t('landing.tracking.title') }}</h2>
      <p>{{ preferences.t('landing.tracking.description') }}</p>
    </div>
  </div>

  <label class="field" [class.is-invalid]="nationalIdTouched && !isNationalIdValid">
    <span>{{ preferences.t('landing.tracking.nationalId.label') }}</span>
    <input
      type="text"
      inputmode="numeric"
      pattern="[0-9]*"
      maxlength="10"
      autocomplete="off"
      name="nationalId"
      [ngModel]="nationalId"
      [placeholder]="preferences.t('landing.tracking.nationalId.placeholder')"
      (ngModelChange)="updateNationalId($event)"
      (blur)="nationalIdTouched = true"
    />
    @if (nationalIdTouched && !isNationalIdValid) {
      <small>
        {{ preferences.t('landing.tracking.nationalId.invalid') }}
      </small>
    }
  </label>

  <label class="field" [class.is-invalid]="mobileNumberTouched && !isMobileNumberValid">
    <span>{{ preferences.t('landing.tracking.mobile.label') }}</span>
    <div class="phone-field">
      <span class="country-code">+966</span>
      <input
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        maxlength="9"
        autocomplete="tel-national"
        name="mobileNumber"
        [ngModel]="mobileNumber"
        [placeholder]="preferences.t('landing.tracking.mobile.placeholder')"
        (ngModelChange)="updateMobileNumber($event)"
        (blur)="mobileNumberTouched = true"
      />
    </div>
    @if (mobileNumberTouched && !isMobileNumberValid) {
      <small>
        {{ preferences.t('landing.tracking.mobile.invalid') }}
      </small>
    }
  </label>

  <p class="tracking-secure">
<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 24 24" fill="none">
  <path opacity="0.16" d="M5.606 5.74L12 3L18.394 5.74C18.574 5.81716 18.7274 5.94548 18.8351 6.10903C18.9428 6.27258 19.0002 6.46416 19 6.66V13.518C19.0001 14.5758 18.7206 15.6149 18.1897 16.5298C17.6588 17.4448 16.8954 18.2031 15.977 18.728L12 21L8.023 18.727C7.10486 18.2023 6.3417 17.4443 5.81083 16.5297C5.27996 15.6151 5.00024 14.5765 5 13.519V6.66C5.00002 6.46433 5.05745 6.27296 5.16516 6.10961C5.27288 5.94626 5.42616 5.81809 5.606 5.741" fill="#1AA8B2"/>
  <path d="M12 3.00089L12.394 2.08089C12.2695 2.02752 12.1355 2 12 2C11.8645 2 11.7305 2.02752 11.606 2.08089L12 3.00089ZM12 21.0009L11.504 21.8689C11.6551 21.9552 11.826 22.0006 12 22.0006C12.174 22.0006 12.3449 21.9552 12.496 21.8689L12 21.0009ZM11.606 2.08189L5.212 4.82089L6 6.66089L12.394 3.92089L11.606 2.08189ZM4 6.65989V13.5199H6V6.65989H4ZM7.527 19.5969L11.504 21.8689L12.496 20.1329L8.519 17.8599L7.527 19.5969ZM12.496 21.8689L16.473 19.5969L15.481 17.8599L11.504 20.1329L12.496 21.8689ZM20 13.5189V6.66089H18V13.5209L20 13.5189ZM18.788 4.82189L12.394 2.08189L11.606 3.91989L18 6.66089L18.788 4.82189ZM20 6.66089C20 6.26955 19.8851 5.88682 19.6697 5.56011C19.4542 5.2334 19.1477 4.97608 18.788 4.82189L18 6.66089H20ZM16.473 19.5969C17.5446 18.9845 18.4353 18.1007 19.0547 17.0331C19.6741 15.9655 20.0002 14.7531 20 13.5189H18C17.9999 14.4004 17.7667 15.2662 17.3242 16.0285C16.8816 16.7909 16.2454 17.4227 15.48 17.8599L16.473 19.5969ZM4 13.5189C3.99994 14.753 4.32615 15.9652 4.94554 17.0325C5.56494 18.0999 6.45551 18.9846 7.527 19.5969L8.519 17.8599C7.75406 17.4227 7.11823 16.7912 6.67587 16.0292C6.23352 15.2673 6.00036 14.4019 6 13.5209L4 13.5189ZM5.212 4.82089C4.85216 4.97515 4.5455 5.23262 4.33005 5.55953C4.11461 5.88643 3.99985 6.26938 4 6.66089H6L5.212 4.82089Z" fill="#1AA8B2"/>
  <path d="M15 10L11 14L9 12" stroke="#1A1A1A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
    {{ preferences.t('landing.tracking.secureHint') }}
  </p>

  @if (trackingError) {
    <small class="form-error">{{ trackingError }}</small>
  }

  <button class="next-button" type="submit" [disabled]="isSearching">
    {{ isSearching ? preferences.t('landing.tracking.searching') : preferences.t('landing.tracking.submit') }}
  </button>
</form>
